import { IngestRuleFormState, ingestRuleFormStateToInfo } from "shared/components/ingest/context";
import { useGraphqlMutation } from "shared/hooks/useGraphql";
import { notify } from "shared/utils/notify";
import { qk } from "shared/utils/qk";
import { graphql } from "src/gql";

export function useIngestRuleActions() {
    const createIngestRule = useGraphqlMutation(muts.createIngestRule);
    const updateIngestRule = useGraphqlMutation(muts.updateIngestRule);
    const deleteIngestRule = useGraphqlMutation(muts.deleteIngestRule);

    return {
        mutations: { createIngestRule, updateIngestRule, deleteIngestRule },

        async create(ingestRuleFormState: IngestRuleFormState) {
            await createIngestRule.mutateAsync(ingestRuleFormStateToInfo(ingestRuleFormState));
            await qk.invalidate("support", "ingest-rules");
            notify.show.success("Created ingest rule.");
        },

        async update(id: string, ingestRuleFormState: IngestRuleFormState) {
            await updateIngestRule.mutateAsync({ id, params: ingestRuleFormStateToInfo(ingestRuleFormState) });
            await qk.invalidate("support", "ingest-rules");
            notify.show.success("Updated ingest rule.");
        },

        async delete(id: string) {
            const { close } = await notify.confirm("Are you sure you want to delete this ingest rule?", {
                title: "Delete Ingest Rule",
                label: "Delete",
                color: "red",
            });

            await deleteIngestRule.mutateAsync({ id });
            await qk.invalidate("support", "ingest-rules");
            close();

            notify.show.success("Deleted ingest rule.");
        },
    };
}

const muts = {
    createIngestRule: graphql(`
        mutation CreateIngestRule($matchKey: String!, $matchExpr: String!, $destinationTemplateId: UUID!) {
            support {
                createIngestRule(params: { matchKey: $matchKey, matchExpr: $matchExpr, destinationTemplateId: $destinationTemplateId }) {
                    id
                }
            }
        }
    `),
    updateIngestRule: graphql(`
        mutation UpdateIngestRule($id: UUID!, $params: IngestRuleInfoInput!) {
            support {
                updateIngestRule(id: $id, params: $params) {
                    id
                }
            }
        }
    `),
    deleteIngestRule: graphql(`
        mutation DeleteIngestRule($id: UUID!) {
            support {
                deleteIngestRule(id: $id) {
                    id
                }
            }
        }
    `),
};
